if (!customElements.get("td-tabs")) {
  class TdTabs extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.TABS_WRAPPER = this.querySelector('[data-tabs-wrapper]')
      this.TRIGGERS = this.querySelectorAll('[data-id]');
      this.TAB_SCROLL_LEFT = this.querySelector('[data-scroll-tab-left]');
      this.TAB_SCROLL_RIGHT = this.querySelector('[data-scroll-tab-right]');
      this.ANIMATED_UNDERLINE = this.querySelector('[data-animated-underline]');
      this.activeTab = this.querySelector('.__tabs-tab.td-active');
      this.activeTabContent = document.querySelector(`#${this.activeTab?.dataset?.id}`);
      if (!this.ANIMATED_UNDERLINE || !this.activeTab || !this.activeTabContent) {
        return
      }

      this.previousWidth = window.innerWidth;

      this.setActiveTab();
      this.setActiveTabNavArrows();
      this.attachListeners();
    }

    attachListeners() {
      this.TRIGGERS.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          this.activeTab = trigger;
          this.setActiveTab();
        })
      })
      this.TABS_WRAPPER.addEventListener('scroll', () => {
        this.setActiveTabNavArrows();
      })
      this.TAB_SCROLL_LEFT.addEventListener('click', () => {
        this.scrollTabs(-100, 'left');
      })
      this.TAB_SCROLL_RIGHT.addEventListener('click', () => {
        this.scrollTabs(100, 'right');
      })
      window.addEventListener('resize', () => {
        this.handleResize();
        this.setActiveTabNavArrows();
      })
    }

    handleResize() {
      const currentWidth = window.innerWidth;
  
      if (currentWidth !== this.previousWidth) {
        this.setActiveTab();
        this.setActiveTabNavArrows();

        this.previousWidth = currentWidth;
      }
    }

    setActiveTab() {
      this.activeTabContent.classList.remove('td-active');
      this.activeTabContent = document.querySelector(`#${this.activeTab?.dataset?.id}`);
      this.ANIMATED_UNDERLINE.style.cssText = `
        left: ${this.activeTab.offsetLeft}px; 
        width: ${this.activeTab.offsetWidth - 0.5}px;
      `;
      this.activeTabContent.classList.add('td-active');
    }

    setActiveTabNavArrows() {
      if (!this.TAB_SCROLL_LEFT || !this.TAB_SCROLL_RIGHT) {
        return
      }
      if (this.isScrollable()) {
        if (this.isScrolledLeft()) {
          this.TAB_SCROLL_LEFT.classList.remove('td-active');
        } else {
          this.TAB_SCROLL_LEFT.classList.add('td-active');
        }
        
        if (this.isScrolledRight()) {
          this.TAB_SCROLL_RIGHT.classList.remove('td-active');
        } else {
          this.TAB_SCROLL_RIGHT.classList.add('td-active');
        }
      } else {
        this.TAB_SCROLL_LEFT.classList.remove('td-active');
        this.TAB_SCROLL_RIGHT.classList.remove('td-active');
      }
    }

    isScrollable() {
      return this.TABS_WRAPPER.scrollWidth > this.TABS_WRAPPER.clientWidth;
    }

    isScrolledLeft() {
      return this.TABS_WRAPPER.scrollLeft === 0;
    }

    isScrolledRight() {
      const tolerance = 1;
      return Math.abs(this.TABS_WRAPPER.scrollLeft + this.TABS_WRAPPER.clientWidth - this.TABS_WRAPPER.scrollWidth) <= tolerance;
    }

    scrollTabs(scrollAmount, direction) {
      const currentScrollPosition = this.TABS_WRAPPER.scrollLeft + scrollAmount;
      if (currentScrollPosition <= 0) {
        this.TABS_WRAPPER.scrollTo({
          left: 0,
          behavior: 'smooth'
        });
      } else if (currentScrollPosition >= (this.TABS_WRAPPER.scrollWidth - this.TABS_WRAPPER.clientWidth)) {
        this.TABS_WRAPPER.scrollTo({
          left: this.TABS_WRAPPER.scrollWidth - this.TABS_WRAPPER.scrollLeft,
          behavior: 'smooth'
        });
      } else {
        this.TABS_WRAPPER.scrollTo({
          left: currentScrollPosition,
          behavior: 'smooth'
        });
      }
    }
  }

  customElements.define("td-tabs", TdTabs);
}